<template>
	<div class="home">
		<HeaderBar title="体格检查"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<van-cell-group v-show="form.bq400tgjc.guid">
					<FormNormalInput label="身高" v-model="form.bq400tgjc.bq400036" readonly />
					<FormNormalInput label="体重" v-model="form.bq400tgjc.bq400037" readonly />
					<FormNormalInput label="BMI" v-model="form.bq400tgjc.bq400038" readonly />
				</van-cell-group>
				<FormNormalUpload label="查看报告" ref="normalUpload" :infoGuid='form.bq400tgjc.guid' disabled>
				</FormNormalUpload>
			</van-form>
		</div>
	</div>
</template>

<script>
	// 引入服务组件
	import componentsModel from '../../../base/components.js'
	// 引入子页面的混入对象
	import mixinModel from '../mixins/mixins.js'
	export default {
		name: "page001",
		mixins: [mixinModel],
		data() {
			return {
				form: {
					bq400tgjc: {
						id: "", //编号
						guid: "", //guid编号
						companyGuid: "", //单位编号
						departmentGuid: "", //部门编号
						checkStatus: "", //审核状态
						dataStatus: "", //数据状态
						addUid: "", //添加人编号
						addTime: "", //添加时间
						bq400guid: "", //随访基本信息表编号
						bq400036: "", //身高
						bq400037: "", //体重
						bq400038: "", //BMI
					},
					sempFiles: []
				},
				bq400: JSON.parse(sessionStorage.getItem('bq400')), //获取随访信息
				fullscreenLoading: false,
				//保存接口
				saveUrl: this.$utils.Url.s400 + '/S400/bq400tgjc/',
			}
		},
		components: {
			...componentsModel
		},
		methods: {
			//加载信息
			LoadInfo: function() {
				var that = this
				var args = {
					bq400guid: this.bq400.guid
				}
				that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq400tgjc/Info', args,
					function(d) {
						let dataModel = d.Data
						that.$utils.CopyKeyInfo(dataModel, dataModel)
						that.$utils.CopyPro(dataModel, that.form.bq400tgjc)
						console.log(that.form.bq400tgjc);
					}, null, null, null);
			},
			//保存信息
			SaveInfo: function() {
				let that = this
				that.form.sempFiles = that.$refs.normalUpload.GetFileList()
				that.$refs.btnSave.Save()
			},
			//自动计算BMI
			CalBMI: function() {
				if (this.form.bq400tgjc.bq400036 == '' || this.form.bq400tgjc.bq400037 == '' || isNaN(this.form
						.bq400tgjc.bq400036) || parseFloat(this.form.bq400tgjc.bq400036) == 0 || isNaN(this
						.form.bq400tgjc.bq400037) || parseFloat(this.form.bq400tgjc.bq400037) == 0) {
					this.form.bq400tgjc.bq400038 = ''
					return false
				}
				this.form.bq400tgjc.bq400038 = (parseFloat(this.form.bq400tgjc.bq400037) /
						(parseFloat(this.form.bq400tgjc.bq400036) * parseFloat(this.form.bq400tgjc.bq400036) / 10000))
					.toFixed(2)
			}
		},
		mounted() {
			this.form.bq400tgjc.bq400guid = this.bq400.guid
			console.log(this.form.bq400tgjc.bq400guid);
			this.LoadInfo()
		},
		watch: {
			'form.bq400tgjc.bq400036': {
				handler: function() {
					this.CalBMI()
				},
			},
			'form.bq400tgjc.bq400037': {
				handler: function() {
					this.CalBMI()
				},
			}
		},
	}
</script>

<style scoped>

</style>
